import {Component, OnInit, Input} from '@angular/core';

@Component({
    selector: 'bw-spinner-legacy',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    standalone: false
})
export class SpinnerComponentLegacy implements OnInit {
  @Input() percentProgress?: string;
  @Input() color? = 'blue';

  ngOnInit() {
    switch (this.color) {
      case 'blue':
        this.color = '#005fff';
        break;
      case 'green':
        this.color = 'green';
        break;
      default:
        this.color = '#005fff';
        break;
    }
  }

}
